import HARDCODE from '../../business-const/HardCode/HardCode'



const tipoOrigemClienteList = (idNULL, listaCompleta) => {

    const tipoOrigemClienteListAux = 
        [
            {
                id: 10,
                descricao: 'Recomendação',
                ordem: 10,
                informaClienteRecomendou: 'S',
                informaTipoOrigemClienteOutras: 'N',
            },
            {
                id: 15,
                descricao: 'Recomendação - Outras',
                ordem: 15,
                informaClienteRecomendou: 'N',
                informaTipoOrigemClienteOutras: 'S',
            },
            {
                id: 20,
                descricao: 'Já era cliente',
                ordem: 20,
                informaClienteRecomendou: 'N',
                informaTipoOrigemClienteOutras: 'N',
            },
            {
                id: 30,
                descricao: 'Projeto 150',
                ordem: 30,
                informaClienteRecomendou: 'N',
                informaTipoOrigemClienteOutras: 'N',
            },
            {
                id: 40,
                descricao: 'Lista fria',
                ordem: 40,
                informaClienteRecomendou: 'N',
                informaTipoOrigemClienteOutras: 'N',
            },
            {
                id: 50,
                descricao: 'Marketing Digital',
                ordem: 50,
                informaClienteRecomendou: 'N',
                informaTipoOrigemClienteOutras: 'N',
            },
            {
                id: 900,
                descricao: 'Outras',
                ordem: 900,
                informaClienteRecomendou: 'N',
                informaTipoOrigemClienteOutras: 'S',
            },
        ]

    if (!idNULL || idNULL === HARDCODE.idTipoOrigemClienteIntegracao) {

        tipoOrigemClienteListAux.push(
            {
                id: HARDCODE.idTipoOrigemClienteIntegracao,
                descricao: 'Integração',
                ordem: 910,
                informaClienteRecomendou: 'N',
                informaTipoOrigemClienteOutras: 'N',
            },
        )
    }

    if (!idNULL || idNULL === HARDCODE.idTipoOrigemClienteIntegracaoMarketingDigital) {

        tipoOrigemClienteListAux.push(
            {
                id: HARDCODE.idTipoOrigemClienteIntegracaoMarketingDigital,
                descricao: 'Integração - Marketing Digital',
                ordem: 920,
                informaClienteRecomendou: 'N',
                informaTipoOrigemClienteOutras: 'S',
            },
        )
    }

    if (listaCompleta) {

        tipoOrigemClienteListAux.push(
            {
                id: HARDCODE.idTipoOrigemClienteNaoInformado,
                descricao: 'Não Informado',
                ordem: 990,
                informaClienteRecomendou: 'N',
                informaTipoOrigemClienteOutras: 'N',
            },
        )
    }

    return tipoOrigemClienteListAux
}

export default tipoOrigemClienteList
